<template>
  <div id="app">
    <v-app>
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </v-app>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  background: linear-gradient(to left, black, #202020);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

  .fade-enter, .fade-leave-to {
    opacity: 0;
    transform: translateX(2em);
  }

  .fade-enter-active, .fade-leave-active {
    transition: all 500ms ease;
  }
</style>
